/* eslint-disable */

import {inject} from "@angular/core";
import {toObservable} from "@angular/core/rxjs-interop";
import {ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, Router, UrlTree} from "@angular/router";
import {filter, map, Observable, take} from "rxjs";
import {UserPermission, UserPermissionStore, PageLinks} from "@vision-inspection/shared";

export const UserPermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> => {
  return canActivateRoute(route);
};

export const UserPermissionChildGuard: CanActivateChildFn = (childRoute: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> => {
  return canActivateRoute(childRoute);
};

function canActivateRoute(route: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {
  const router: Router = inject(Router);
  const userPermissionStore: UserPermissionStore = inject(UserPermissionStore);
  const requiredPermissions: UserPermission[] = getRequiredPermissions(route);

  if (requiredPermissions.length === 0) {
    return true;
  }

  const canActivate = (): boolean | UrlTree => {
    if (userPermissionStore.hasPermissions(requiredPermissions)) {
      return true;
    }

    return router.parseUrl(PageLinks.FORBIDDEN_403);
  };

  if (!userPermissionStore.isLoading()) {
    return canActivate();
  }

  return toObservable(userPermissionStore.isLoading)
    .pipe(
      filter((isLoading: boolean): boolean => !isLoading),
      take(1),
      map((): boolean | UrlTree => canActivate())
    );
}

function getRequiredPermissions(route: ActivatedRouteSnapshot): UserPermission[] {
  const userPermission: unknown = route.data['userPermission'];

  if (!userPermission) {
    return [];
  }

  if (Array.isArray(userPermission)) {
    return userPermission as UserPermission[];
  }

  return [userPermission as UserPermission];
}
